export const TEST_ID = 'touchIcon';
